// assets/cart.imprint.js
window.CartMethodsImprint = {
    buildImprintLinesArrayForUpdate(imprintLinesArray) {

        if (!Array.isArray(imprintLinesArray) || imprintLinesArray.length === 0) {
            return [];
        }

        // Check if any location has text lines OR image data with a color.
        const hasAnyContent = imprintLinesArray.some(
            location =>
                (Array.isArray(location.lines) && location.lines.length > 0) ||
                (location['Image Data'] && location['Image Data']['Image Color'])
        );

        if (!hasAnyContent) {
            return [];
        }

        return imprintLinesArray.map(location => {
            const uniqueColors = [];

            if (location.lines && Array.isArray(location.lines)) {
                location.lines.forEach((line, index) => {
                    const lineNum = index + 1;
                    const colorKey = `Line ${lineNum} color`;
                    const colorSKUKey = `Line ${lineNum} Color SKU`;

                    // Додаємо тільки якщо є SKU (не custom color)
                    if (line[colorKey] && line[colorSKUKey] && !uniqueColors.includes(line[colorKey])) {
                        uniqueColors.push(line[colorKey]);
                    }
                    if (line[colorKey] && !line[colorSKUKey] && !uniqueColors.includes(line[colorKey])) {
                        uniqueColors.push(line[colorKey]);
                    }
                });
            }

            if (location['Image Data'] && location['Image Data']['Image Color']) {
                if (location['Image Data']['Image Color SKU'] && !uniqueColors.includes(location['Image Data']['Image Color'])) {
                    uniqueColors.push(location['Image Data']['Image Color']);
                }
            }

            return uniqueColors;
        });
    },

    imprintChangeName(propName) {
        if(propName == undefined){
            return;
        }
        propName = propName.replace(' text', '');

        if(propName.toLowerCase().indexOf('color') != -1) {
            propName = window.Shopify.country === "CA"? "Colour": "Color"
        }

        if(propName === 'Imprint location' ){
            propName = "Location"
        }

        if(propName === 'Imprint Method' ){
            propName = "Imprint Type"
        }

        return propName;
    },

    isCalendarProduct(cartItemProperties) {
        let result = false;

        this.calendarStandartProps.forEach( el => {
            if(Object.hasOwn(cartItemProperties,el)) {
                result = true;
            }
        });
        return result;
    },

    hasImprintLines(prID) {
        return !!this.properties[prID]?.['_Imprint Lines']?.length;
    },

    // True when running on MLP store — controls fee accordion display logic
    isMlp() {
        const host = window.location.hostname;
        return host.includes('mapleleaf') || host.includes('mlp');
    },
};